var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwipeTutLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 111,
    viewBox: "0 0 4 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.5C2.82843 0.5 3.5 1.17157 3.5 2L3.5 109C3.5 109.828 2.82842 110.5 2 110.5C1.17157 110.5 0.499995 109.828 0.499995 109L0.5 2C0.5 1.17157 1.17157 0.5 2 0.5Z",
    fill: "url(#paint0_linear_11590_576)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11590_576",
    x1: 0.49885,
    y1: 2,
    x2: 0.498849,
    y2: 99.4696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeTutLine);
export default __webpack_public_path__ + "static/media/swipe_tut_line.74923b8262a0fabdec47d7d3be03bce3.svg";
export { ForwardRef as ReactComponent };